export default "__VITE_ASSET__Cy_zceGr__"